<template>
    <new-admin-account-form></new-admin-account-form>
</template>

<script>

import NewAdminAccountForm from '@/components/NewAdminAccountForm'

export default {
    components:{
        'new-admin-account-form': NewAdminAccountForm
    },

    name: 'AdminAccountInvitation',
}
</script>

<style scoped>

</style>